<div class="grid">
  <div class="col-12">
    <div class="card">
      <h5 translate>ORDERS.ORDERS</h5>
      <p-table #dt
               [value]="orders"
               [lazy]="true"
               (onLazyLoad)="pageChanged($event)"
               [(selection)]="selectedOrder"
               dataKey="id"
               [rowHover]="true"
               [rows]="filter.limit"
               [totalRecords]="(count$ | async) || 0"
               [showCurrentPageReport]="true"
               [rowsPerPageOptions]="[10,15,20,50,200]"
               [loading]="loading"
               [paginator]="true"
               sortField="dateCreated"
               [sortOrder]="-1"
               currentPageReportTemplate="{{'TABLE.SHOWING' | translate}}"
               [filterDelay]="0"
               [globalFilterFields]="['order.number', 'dateCreated', 'buyer.name']">
        <ng-template pTemplate="caption">
          <div class="flex flex-column sm:flex-row sm:align-items-center sm:justify-content-between gap-3 table-header">
            <span class="p-input-icon-left">
              <p-button icon="pi pi-plus" class="p-button-raised w-full" (click)="openModal(null, null)"
                        [label]="'ORDERS.CREATE_ORDER' | translate"></p-button>
            </span>
            <p-iconfield class="table-search ml-auto" iconPosition="left">
                <p-inputicon>
                    <i class="pi pi-search"></i>
                </p-inputicon>
                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                           placeholder="{{'TABLE.GLOBAL_SEARCH' | translate}}" class="w-full"/>
            </p-iconfield>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="number">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.NUMBER
                <p-sortIcon field="number"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="buyer.name">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.CUSTOMER
                <p-sortIcon field="buyer.name"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="createdBy">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.CREATED_BY
                <p-sortIcon field="createdBy"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="dateCreated">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.DATE_CREATED
                <p-sortIcon field="dateCreated"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="dateValid">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.DATE_ISSUED
                <p-sortIcon field="dateValid"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="dateDelivery">
              <div class="flex justify-content-between align-items-center" translate>
                OFFERS.DATE_DELIVERY
                <p-sortIcon field="dateDelivery"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="priceTotalGross">
              <div class="flex justify-content-between align-items-center" translate>
                OFFER.PRICE
                <p-sortIcon field="priceTotalGross"></p-sortIcon>
              </div>
            </th>
            <th style="width: 6.5rem"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-order>
          <tr class="p-row">
            <td (click)="viewOrder(order.id)" style="cursor: pointer;">
              {{order.number}}
            </td>
            <td (click)="viewCustomer(order.buyer.id)" style="cursor: pointer;">
              {{order.buyer?.name}}
            </td>
            <td>
              {{order.createdBy}}
            </td>
            <td>
              {{order.dateCreated | date: 'dd.MM.yyyy'}}
            </td>
            <td>
              {{order.dateValid | date: 'dd.MM.yyyy'}}
            </td>
            <td>
              {{order.dateDelivery | date: 'dd.MM.yyyy'}}
            </td>
            <td>
              {{order.priceTotalGross|currency: 'EUR':'symbol'|empty}}
            </td>
            <td>
              <button pButton type="button" class="p-button-label table-button mr-2" icon="pi pi-pencil"
                      (click)="openModal(null, order)"></button>
              <button pButton type="button" class="p-button-danger table-button" icon="pi pi-trash"
                      (click)="delete(order)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="8" translate>ORDERS.NO_ORDERS_FOUND</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>


